import React, { useState, useEffect, useRef } from "react";
import { getAutoComplete } from "../api/getAutoComplete";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Header from "../Header/Header";
import "./styleConocimientoVial.css";
import Modal from 'react-bootstrap/Modal';

function QuestionConocimientoVial() {

  const isRunned = useRef(false);
  const [respuestaSeleccionada, setRespuestaSeleccionada] = useState("");
  const [preguntasAll, setPreguntasAll] = useState([]);
  const [preguntaActual, setPreguntaActual] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validateButtonNextQ, setValidateButtonNextQ] = useState(false);
  const [preguntaActualGlobal, setPreguntaActualGlobal] = useState(0);
  const [respuestaActual, setRespuestaActual] = useState(0);
  const [isInputReadOnly, setIsInputReadOnly] = useState(false);
  const [preguntasContestadas, setPreguntasContestadas] = useState(0);
  const [totalPreguntas, setTotalPreguntas] = useState(0);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState('');

  const handleClose = () => {
    setShow(false);
  }

  useEffect
    (() => {

      if (isRunned.current) return;
      isRunned.current = true;

      async function createSession() {
        setLoading(true);
        const dataJson = await getAutoComplete();
        setTotalPreguntas(dataJson.preguntas.length);
        dataJson.preguntas[0].cpv = "" + localStorage.getItem("sCpv");
        setPreguntasAll(dataJson);
        setPreguntaActual(dataJson.preguntas[0]);
        setLoading(false);
      }
      createSession();
    }, []);

  function handleRespuestaSeleccionada(respuesta) {

    let i = 0;
    preguntasAll.preguntas[preguntaActualGlobal].respuestaCorrectaTxt = respuesta.value;
    preguntasAll.preguntas[preguntaActualGlobal].respuestas.forEach(function (item, index) {
      if (preguntasAll.preguntas[preguntaActualGlobal].respuestas[index] === respuesta.value) {
        i = index;
        return;
      }
    });

    preguntasAll.preguntas[preguntaActualGlobal].respuestaCorrecta = "" + i;
    setValidateButtonNextQ(true);
    setRespuestaSeleccionada(respuesta);
  }

  function handleSiguientePregunta() {
    const indicePreguntaActual = preguntasAll.preguntas.findIndex(
      (pregunta) => pregunta.id === preguntaActual.id
    );
    if (indicePreguntaActual < preguntasAll.preguntas.length - 1) {
      setPreguntaActual(preguntasAll.preguntas[indicePreguntaActual + 1]);
      setPreguntaActualGlobal(indicePreguntaActual + 1);
      setPreguntasContestadas(preguntasContestadas + 1);
      setRespuestaActual(indicePreguntaActual);
      setRespuestaSeleccionada("");
      setValidateButtonNextQ(false);
    } else {
      onTest();
    }
  }

  const navigate = useNavigate();

  const onTest = async () => {
    navigate("/ValidarDataVial", {
      state: {
        preguntas: preguntasAll
      }
    });
  };

  const handleInputFocus = () => {
    setIsInputReadOnly(true);
  }

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Conocimiento vial"
          name="QuestionConocimientoVial"
        />

        {loading ? (
          <div className="containerRender">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="containerRender">
            <div className="containerInfo_P2">
              <div className="containerIdent_P2">
                <div className="conteoPreguntas">
                  <div className="tiitleExp animate__animated animate__fadeIn">{preguntaActual.seccion}</div>
                  <div>
                    {preguntasContestadas}/{totalPreguntas}
                  </div>
                </div>
                <hr className="colorCFCFCF" />
                <div>
                  <div className="textQuestion animate__animated animate__fadeIn">{preguntaActual.pregunta}</div>
                  <div>
                    <Select
                      placeholder="Selecciona una respuesta"
                      value={respuestaSeleccionada}
                      onChange={handleRespuestaSeleccionada}
                      options={preguntaActual.respuestas?.map((respuesta) => ({
                        label: respuesta,
                        value: respuesta,
                      }))}
                      isSearchable={false}
                      readOnly={isInputReadOnly}
                      onFocus={handleInputFocus}
                    />
                  </div>
                  <hr className="colorCFCFCF" />
                  {!validateButtonNextQ ? (
                    <>
                      <button className='btnVer_P3'>
                        <span className='txtVer_P3'>Continuar</span>
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="button_P2 animate__animated animate__fadeIn"
                        onClick={handleSiguientePregunta}>
                        <span className="txtButton_P2">Continuar</span>
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default QuestionConocimientoVial;
